import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ExternalLink } from 'lucide-react';
import JobStatusBadge from '../JobStatusBadge';
import useJobConfig from '../../hooks/useJobConfig';

const fmt = (d) => (d ? new Date(`${d}T12:00:00Z`).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—');

export default function CustomerJobsTab({ jobs }) {
  const navigate = useNavigate();
  const { labelForType } = useJobConfig();

  return (
    <div className="bg-white border border-slate-200 rounded-lg shadow-sm overflow-x-auto" data-testid="customer-jobs-tab">
      <table className="w-full min-w-[760px]" data-testid="customer-jobs-table">
        <thead className="bg-slate-50 border-b border-slate-200">
          <tr>
            {['Job #', 'Type', 'Status', 'Start', 'LSD', 'Assigned Techs', ''].map((h, i) => (
              <th key={i} className="px-4 py-3 text-left text-xs font-bold uppercase text-slate-500 whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-200">
          {(jobs || []).map((j) => (
            <tr key={j.id} className="hover:bg-slate-50" data-testid={`customer-job-row-${j.id}`}>
              <td className="px-4 py-3 text-sm">
                <p className="font-semibold text-slate-900">#{j.job_number}</p>
                {j.description && <p className="text-xs text-slate-500 truncate max-w-[260px]">{j.description}</p>}
              </td>
              <td className="px-4 py-3 text-sm text-slate-700">{labelForType(j.job_type) || j.job_type}</td>
              <td className="px-4 py-3"><JobStatusBadge status={j.status} /></td>
              <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap">{fmt(j.start_date)}</td>
              <td className="px-4 py-3 text-sm text-slate-600 font-mono">{j.customer_lsd || <span className="text-slate-400">—</span>}</td>
              <td className="px-4 py-3 text-sm text-slate-700">
                {j.assigned_tech_names?.length ? (
                  <div className="flex flex-wrap gap-1">
                    {j.assigned_tech_names.map((n) => (
                      <span key={n} className="px-2 py-0.5 bg-slate-100 border border-slate-200 rounded-full text-xs">{n}</span>
                    ))}
                  </div>
                ) : <span className="text-slate-400">Unassigned</span>}
              </td>
              <td className="px-4 py-3 text-right">
                <Button size="sm" variant="outline" onClick={() => navigate(`/jobs/${j.id}`)} data-testid={`customer-job-open-${j.id}`}>
                  <ExternalLink size={13} className="mr-1.5" /> Open
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {(jobs || []).length === 0 && (
        <div className="p-12 text-center text-slate-500 text-sm" data-testid="customer-jobs-empty">No jobs linked to this customer yet.</div>
      )}
    </div>
  );
}
